import React, { useEffect } from 'react';
import AniLink from 'gatsby-plugin-transition-link/AniLink';
import ReactMarkdown from 'react-markdown';
import { gsap } from 'gsap';

//Components
import Image from './image';
import useObserver from './useObserver';

const SectionAbout = ({ data, lang }) => {
  const [ref, setRef, animate] = useObserver({
    init: true,
    root: null,
    rootMargin: `-20% 0% -20% 0%`,
  });

  useEffect(() => {
    if (ref && window.innerWidth > 767) {
      const title = ref.querySelector('.section__title');
      const entry = ref.querySelector('.markdown-preview');
      const btn = ref.querySelector('.btn');
      const imageWrapper = ref.querySelector('.section__image');
      const image = ref.querySelector('.gatsby-image-wrapper');

      gsap.set(image, {
        opacity: 0,
      });

      gsap.set(imageWrapper, {
        opacity: 0,
        xPercent: -100,
        force3D: true,
      });

      gsap.set(title, {
        opacity: 0,
        yPercent: 10,
        force3D: true,
      });

      gsap.set(entry, {
        opacity: 0,
        yPercent: 10,
        force3D: true,
      });

      gsap.set(btn, {
        opacity: 0,
      });
    }
  }, [ref]);

  useEffect(() => {
    if (animate) {
      const title = ref.querySelector('.section__title');
      const entry = ref.querySelector('.markdown-preview');
      const btn = ref.querySelector('.btn');
      const imageWrapper = ref.querySelector('.section__image');
      const image = ref.querySelector('.gatsby-image-wrapper');

      gsap.to(imageWrapper, {
        duration: 0.7,
        opacity: 1,
        xPercent: 0,
        force3D: true,
        ease: 'expo.out',
      });

      gsap.to(image, {
        duration: 0.4,
        opacity: 1,
        delay: 0.4,
        ease: 'power1.out',
      });

      gsap.to(title, {
        duration: 0.4,
        yPercent: 0,
        opacity: 1,
        delay: 0.7,
        ease: 'power2.out',
      });

      gsap.to(entry, {
        duration: 0.4,
        yPercent: 0,
        opacity: 1,
        delay: 1,
        ease: 'power2.out',
      });

      gsap.to(btn, {
        duration: 0.4,
        opacity: 1,
        delay: 1,
        ease: 'power3.out',
      });
    }
  }, [animate, ref]);

  return (
    <section className="section-about py-7 pt-md-25 pb-md-12 pt-xl-30 pt-mg-42 pb-lg-8 pb-xl-13 pb-mg-19">
      <div className="container">
        <div className="row align-items-start" ref={setRef}>
          <div className="section__image mb-7 mb-lg-0 col-lg-6 col-xl-7">
            <div className="section__image-decoration"></div>

            <Image image={data.image} alt={data.title} />
          </div>

          <div className="col-lg-6 col-xl-5 mb-lg-0 pr-mg-11">
            <h2 className="section__title text-mega pb-4 mb-4 pb-md-7 mb-md-7">
              {data.title}
            </h2>

            <div className="markdown-preview pl-mg-16">
              <ReactMarkdown source={data.entry} />
            </div>

            <div className="pl-mg-16">
              <AniLink
                cover
                direction="up"
                bg="#092431"
                className="btn btn-outline-primary d-block d-md-inline-block rounded-lg mt-7"
                to={`/${lang}/about`}
              >
                {data.title}
              </AniLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionAbout;
